import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import { Translation, getI18n } from 'react-i18next';
import { Button, Checkbox, Form, Table } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import Logger from '../../../../../lib/Logger';
import message from '../../../elements/lib/MessageWrapper';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const PartnershipAccountAccessForm = ({
  data,
  activeId,
  trackerActions,
  ...props
}) => {
  const [accessToken, setAccessToken] = useState('access-token');
  const [valuesAccess, setValuesAccess] = useState(
    data.access_role_admin_in_app
  );

  const [form] = Form.useForm();

  useEffect(() => {
    setValuesAccess({ ...data.access_role_admin_in_app });
  }, [data]);

  const accessOptions = [
    'partnership_account',
    'register_code',
    'journal_partner_tags',
    'user_roles',
    'calendar',
    'resources',
    'care_guides',
    'care_guide_partner_tags',
    'dashboard',
    'learnings',
    'forms',
  ];

  const accessColumns = [
    {
      title: getI18n().t(
        'partnership_account_access_admin_form_table_access_title'
      ),
      dataIndex: 'access_type',
    },
    {
      title: getI18n().t(
        'partnership_account_access_admin_form_input_access_admin'
      ),
      dataIndex: 'access_role_admin_in_app',
    },
  ];
  const accessData = accessOptions.map((x, i) => {
    return {
      key: i,
      access_type: getI18n().t('partnership_accounts_access_' + x),
      access_role_admin_in_app: (
        <Checkbox
          name='access_role_admin_in_app'
          checked={valuesAccess[x]}
          onChange={(e) => onChangeAccess(x)}
        ></Checkbox>
      ),
    };
  });

  const onChangeAccess = (val) => {
    if (valuesAccess[val]) {
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER
          .PARTNERSHIP_ACCOUNT_DESACTIVE_TAB_PARTNER_ADMIN,
        { tab: getI18n().t('partnership_accounts_access_' + val) }
      );

      setValuesAccess({ ...valuesAccess, [val]: false });
    } else {
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER
          .PARTNERSHIP_ACCOUNT_ACTIVE_TAB_PARTNER_ADMIN,
        { tab: getI18n().t('partnership_accounts_access_' + val) }
      );
      setValuesAccess({ ...valuesAccess, [val]: true });
    }
  };

  useEffect(() => {
    setAccessToken('access-' + Object.keys(valuesAccess).join(','));
  }, [valuesAccess]);

  // handle errors reported by API
  useEffect(() => {
    let firstFieldName = '';
    for (const field in props.errors) {
      form.setFields([{ name: field, errors: props.errors[field] }]);
      if (firstFieldName === '') {
        firstFieldName = field;
      }
    }
    form.scrollToField(firstFieldName);
  }, [form, props.errors]);

  // submit data handler
  const submitData = async (values) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER
        .PARTNERSHIP_ACCOUNT_SUBMIT_TABS_PARTNER_ADMIN
    );

    Logger.log('debug', `PartnershipAccountAccessForm.submitData(###)`);
    // API POST/PUT payload
    const payload = {
      access_role_admin_in_app: valuesAccess,
    };
    // update
    props.submit(activeId, payload, (success) => {
      if (success) {
        storage.set(findStorageType(), 'partnershipData', {
          access_role_admin_in_care_guide: storage.get(
            findStorageType(),
            'partnershipData'
          )?.access_role_admin_in_care_guide,
          access_role_admin_tabs_members: storage.get(
            findStorageType(),
            'partnershipData'
          )?.access_role_admin_tabs_members,
          access_role_admin_in_app: valuesAccess,
          access_tabs_in_app: storage.get(findStorageType(), 'partnershipData')
            ?.access_tabs_in_app,
          role: storage.get(findStorageType(), 'partnershipData')?.role,
          name: storage.get(findStorageType(), 'partnershipData')?.name,
          show_only_active_members: storage.get(
            findStorageType(),
            'partnershipData'
          )?.show_only_active_members,
        });

        message.success(
          i18next.t('partnership_account_access_admin_form_message_success')
        );
      } else {
        message.error(
          i18next.t('partnership_account_access_admin_form_message_failure')
        );
      }
    });
  };

  // form submit handler
  const handleFinish = async (values) => {
    Logger.log('debug', `PartnershipAccountAccessForm.handleFinish(###)`);
    if (!props.isSubmitting) {
      await submitData(values);
    }
  };

  // form error handler
  const handleFinishFailed = ({ values, errorFields, outOfDate }) => {
    Logger.log('debug', `PartnershipAccountAccessForm.handleFinishFailed(###)`);
    message.error(getI18n().t('feedback_form_error'));
    if (errorFields && errorFields.length > 0) {
      form.scrollToField(errorFields[0].name);
    }
  };

  return (
    <Translation>
      {(t) => (
        <div className='partnership-account-access-form'>
          <Form
            name='partnership_access_account_form'
            onFinish={handleFinish}
            onFinishFailed={handleFinishFailed}
            form={form}
          >
            <Table
              key={accessToken}
              columns={accessColumns}
              dataSource={accessData}
              size='small'
              pagination={false}
            />

            <div className='form-actions'>
              <Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  icon={<CheckCircleOutlined />}
                  loading={props.isSubmitting}
                >
                  {t('partnership_account_access_admin_form_button_submit')}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      )}
    </Translation>
  );
};

export default PartnershipAccountAccessForm;

Logger.log('silly', `PartnershipAccountAccessForm loaded.`);
